import React, { useEffect, useState } from "react";
import {
  Form,
  Button,
  Table,
  Container,
  Row,
  Col,
  Modal,
  Spinner,
  Pagination,
  ModalFooter,
} from "react-bootstrap";
import "../../css/admin/adminDashboard.css";
import { apiPost, downloadDoc } from "../../service/admin/apiService";
import { showSuccess, showError } from "../../utils/toast";
import AdminScreenHeader from "../admin/adminScreenHeader";
import Loader from "../loader";
import { FaEdit, FaFileUpload } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import { FaDownload, FaUpload } from "react-icons/fa";
import moment from "moment";

import {
  BsPlus,
  BsX,
  BsSend,
  BsCheck,
  BsFileCheck,
  BsList,
} from "react-icons/bs";

const ClientUploadedDocs = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [activePage, setActivePage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [showLoader, setShowLoader] = useState(false);
  const [maxPage, setMaxPage] = useState(1);
  const [uploadedDoc, setUploadedDocs] = useState([]);
  const [downloadingId, setDownloadingId] = useState(null);
  const [clientList, setClientList] = useState([]);
  const navigate = useNavigate();
  const tk = localStorage.getItem("tk") || "";
  let ui = localStorage.getItem("ui");

  useEffect(() => {
    getClientUploadedDocs();
  }, []);

  const filteredClientData = uploadedDoc.filter((data) => {
    const clientName = `${data?.documentname}`.toLowerCase();
    const term = searchTerm?.toLowerCase();
    return (
      data?.documentname.toLowerCase().includes(term) ||
      clientName.includes(term)
    );
  });

  useEffect(() => {
    const calculatedMaxPage = Math.ceil(filteredClientData.length / limit) || 1;
    setMaxPage(calculatedMaxPage);
    if (activePage > calculatedMaxPage) setActivePage(1);
  }, [filteredClientData, limit]);

  // useEffect(() => {
  //   if (clientList.length > 0) {
  //     setClientName();
  //   }
  // }, [uploadedDoc]);

  useEffect(() => {
    setTimeout(() => {
      setClientName();
    }, 300);
  }, [clientList]);

  // const setClientName = async () => {
  //   const lookup = {};
  //   clientList.forEach((item) => {
  //     const key = String(item.ci).trim(); // convert to string and trim spaces
  //     lookup[key] = item.cn;
  //   });

  //   const upDoc = uploadedDoc.map((item) => {
  //     const key = String(item.clientid).trim();
  //     return {
  //       ...item,
  //       clientName: lookup[key] || null,
  //     };
  //   });
  //   setUploadedDocs(upDoc);
  // };
  const setClientName = async () => {
    const lookup = {};

    clientList.forEach((item) => {
      const key = String(item.ci).trim();
      lookup[key] = {
        clientName: item.cn,
        clientFileNo: item.fno,
        clientTanNo: item.ta,
      };
    });

    const upDoc = uploadedDoc.map((item) => {
      const key = String(item.clientid).trim();
      const clientData = lookup[key] || {};

      return {
        ...item,
        clientName: clientData.clientName || null,
        clientFileNo: clientData.clientFileNo || null,
        clientTanNo: clientData.clientTanNo || null,
      };
    });

    setUploadedDocs(upDoc);
  };

  const getClientList = async () => {
    const payload = {
      action: "userclientlinklist",
      to: tk,
      ui: ui,
    };

    if (tk && tk !== "") {
      try {
        const response = await apiPost(process.env.REACT_APP_API_URL, payload);
        if (Number(response?.errordetails?.errorcode) > 0) {
          showError(response?.errordetails?.error);
          setShowLoader(false);
        } else if (response?.responsedetails) {
          console.log("clientlist", response?.responsedetails);
          const clist = response?.responsedetails?.filter((el) => el.li != 0);
          if (clist) {
            setClientList(clist);
            setShowLoader(false);
          }
        }
      } catch (err) {
        console.error("Error:", err);
        setShowLoader(false);
      }
    }
  };

  const getClientUploadedDocs = async () => {
    setShowLoader(true);
    const payload = {
      action: "listdocument",
      to: tk,
    };

    try {
      const response = await apiPost(process.env.REACT_APP_API_URL, payload);
      console.log("uploadedDocs", response?.responsedetails);
      if (Number(response?.errordetails?.errorcode) > 0) {
        showError(response?.errordetails?.error);
      } else if (response?.responsedetails) {
        if (response?.responsedetails) {
          setUploadedDocs(response?.responsedetails || []);
          getClientList();
        }
      }
    } catch (err) {
      setShowLoader(false);
      console.error("Error fetching data to review", err);
    }
  };

  const openUploadDocument = () => {
    navigate("/client-document");
  };

  const handleFileDonwload = async (docId, docName) => {
    if (tk) {
      setDownloadingId(docId);
      try {
        const payload = {
          action: "downloaddocument",
          to: tk,
          id: docId,
        };

        const response = await downloadDoc(
          process.env.REACT_APP_API_URL,
          payload,
          docName
        );
        console.log("res", response);
        setDownloadingId(null);
        getClientUploadedDocs();
      } catch (error) {
        setDownloadingId(null);
        console.error("Download failed:", error);
      }
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > maxPage) return;
    setActivePage(pageNumber);
  };

  const getRowStyle = (isDownloaded) => ({
    backgroundColor: isDownloaded == false ? "#c8e9fd" : "white",
  });

  return (
    <Container className="mt-4 ">
      <div className="d-none d-md-block mt-3">
        <AdminScreenHeader
          title="📋 Client Documents"
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          placeholder="Search Client"
          showSearch={true}
        />
        <div className="d-flex justify-content-end">
          <Button
            size="sm"
            variant="success btn-primary-submit-to-ca"
            className="mb-2 d-flex align-items-center gap-2"
            onClick={() => {
              openUploadDocument();
            }}
          >
            Upload
            <FaUpload size={15} />
          </Button>
        </div>
        <div
          className="fixed-table"
          style={{ maxHeight: "500px", overflowY: "auto" }}
        >
          <Table
            striped
            bordered
            hover
            responsive
            className="w-100 custom-table text-primary"
            style={{ verticalAlign: "middle" }}
          >
            <thead>
              <tr>
                <th style={{ width: "30%" }}>Client Name</th>
                <th style={{ textAlign: "center", width: "10%" }}>
                  Financial Year
                </th>
                <th style={{ textAlign: "center", width: "7%" }}>Month</th>
                <th style={{ textAlign: "center", width: "12%" }}>
                  Uploaded Date
                </th>
                <th style={{ textAlign: "center", width: "12%" }}>
                  Downloaded Date
                </th>
                <th style={{ textAlign: "center", width: "35%" }}>
                  Document Name
                </th>
                <th style={{ textAlign: "center", width: "5%" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredClientData
                .sort((a, b) => a.isdownloaded - b.isdownloaded)
                .slice((activePage - 1) * limit, activePage * limit)
                .map((clientData, index) => (
                  <tr key={index}>
                    <td style={getRowStyle(clientData?.isdownloaded)}>
                      {clientData?.clientName}
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        ...getRowStyle(clientData?.isdownloaded),
                      }}
                    >
                      {clientData.fyname}
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        ...getRowStyle(clientData?.isdownloaded),
                      }}
                    >
                      {clientData.documentmonth}
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        ...getRowStyle(clientData?.isdownloaded),
                      }}
                    >
                      {moment(
                        clientData.datecreated,
                        "YYYY-MM-DD HH:mm:ss"
                      ).format("DD/MM/YYYY HH:mm")}
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        ...getRowStyle(clientData?.isdownloaded),
                      }}
                    >
                      {clientData.isdownloaded === 0
                        ? ""
                        : moment(
                            clientData.datedownloaded,
                            "YYYY-MM-DD HH:mm:ss"
                          ).format("DD/MM/YYYY HH:mm")}
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        ...getRowStyle(clientData?.isdownloaded),
                      }}
                    >
                      {clientData.documentname}
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        cursor: "pointer",
                        ...getRowStyle(clientData?.isdownloaded),
                      }}
                    >
                      {downloadingId === clientData.id ? (
                        <Spinner
                          animation="border"
                          size="sm"
                          className="me-2"
                        />
                      ) : (
                        <FaDownload
                          onClick={() =>
                            handleFileDonwload(
                              clientData.id,
                              `${clientData.clientFileNo}-${clientData.clientTanNo}-${clientData.documentname}`
                            )
                          }
                        />
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>
        <Row className="mt-3 mb-3">
          <Col className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <label
                className="me-2 mb-0"
                style={{ color: "#0d6efd", fontSize: "13px" }}
              >
                Records per page:
              </label>
              <Form.Select
                value={limit}
                onChange={(e) => {
                  const value =
                    e.target.value === "All"
                      ? filteredClientData.length
                      : parseInt(e.target.value);
                  setLimit(value);
                  setActivePage(1);
                }}
                style={{ width: "100px" }}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100000">All</option>
              </Form.Select>
            </div>

            {/* Pagination */}
            <Pagination className="mb-0">
              <Pagination.First
                onClick={() => handlePageChange(1)}
                disabled={activePage === 1}
              />
              <Pagination.Prev
                onClick={() => handlePageChange(activePage - 1)}
                disabled={activePage === 1}
              />
              <Pagination.Item>
                {`Page ${activePage} of ${maxPage}`}
              </Pagination.Item>
              <Pagination.Next
                onClick={() => handlePageChange(activePage + 1)}
                disabled={activePage >= maxPage}
              />
              <Pagination.Last
                onClick={() => handlePageChange(maxPage)}
                disabled={activePage >= maxPage}
              />
            </Pagination>
          </Col>
        </Row>
      </div>
      {showLoader ? <Loader show={showLoader} /> : null}
    </Container>
  );
};

export default ClientUploadedDocs;
